import { api, sp } from "./_base";


export const getAlloyBlackboxByConfig = async (configId, schemaName = null) => {
  try {
    const response = await api.get(`/alloy-blackbox/`, { params: { alloy_config: configId, ...sp(schemaName) } });
    return response.data;
  } catch (error) {
    console.error("Error fetching Blackbox jobs:", error);
    throw error;
  }
};

export const getAlloyBlackboxById = async (id, schemaName = null) => {
  try {
    const response = await api.get(`/alloy-blackbox/${id}/`, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error fetching Blackbox job:", error);
    throw error;
  }
};

export const createAlloyBlackbox = async (data, schemaName = null) => {
  try {
    const response = await api.post("/alloy-blackbox/", data, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error creating Blackbox job:", error);
    throw error;
  }
};

export const updateAlloyBlackbox = async (id, data, schemaName = null) => {
  try {
    const response = await api.put(`/alloy-blackbox/${id}/`, data, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error updating Blackbox job:", error);
    throw error;
  }
};

export const deleteAlloyBlackbox = async (id, schemaName = null) => {
  try {
    const response = await api.delete(`/alloy-blackbox/${id}/`, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error deleting Blackbox job:", error);
    throw error;
  }
};
